import React, { Component } from 'react'
import { H3, P, Div, Button, Footer, Span } from '@driftt/tide-core-legacy'
import { Modal } from '@driftt/tide-core-legacy'
import Countdown from "react-countdown-now"

import './style.styl'

const countdownRenderer = ({ seconds, minutes }) => {
  if (minutes <= 0){
    return <Span className="timeout-modal-seconds-countdown-span">{seconds} second{seconds > 1 ? 's' : ''}</Span>
  }
  else {
    return <Span className="timeout-modal-minutes-countdown-span">{minutes} minute{minutes > 1 ? 's' : ''}</Span>
  }
}

export class TimeoutModal extends Component{


  shouldComponentUpdate() {
    //don't update after initial render so we don't reset the modal timer once it's started
    return false
  }

  render(){
    const { cancel, logOut, modalTime } = this.props
    const countDown = <Countdown onComplete={() => logOut(true)} date={Date.now() + modalTime} renderer={countdownRenderer}/>
    return (
      <Div>
        <Modal className="session-timeout-modal" size ='small' type="warning" open={true} onClose={cancel}>
          <H3 className="session-timeout-modal-heading">Still here?</H3>
          <P>For your security, your session will expire in {countDown} due to inactivity and you will be logged out. </P>
          <P>Click “continue” to keep using Drift or “log out” to end your session</P>
          <Footer className="session-timeout-modal-footer">
            <Button className="session-timeout-modal-continue-button" type="secondary" onClick={cancel}>
              Continue
            </Button>
            <Button className="session-timeout-modal-logout-button" type="tertiary" onClick={() => logOut(false)}>
              Log out
            </Button>
          </Footer>
        </Modal>
      </Div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scripts/components/IdleTimeout/TimeoutModal/index.js